"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.widgets_en_us = void 0;
function widgets_en_us() {
    return {
        "widgets.contacts.columns.avatar": "Avatar",
        "widgets.contacts.columns.firstname": "First Name",
        "widgets.contacts.columns.lastname": "Last Name",
        "widgets.contacts.columns.company": "Company",
        "widgets.contacts.columns.email": "Email",
        "widgets.contacts.columns.phone": "Phone",
        "widgets.contacts.columns.mobile": "Mobile",
        "widgets.contacts.columns.actions": "Actions",
        "widgets.datatable.errors.notconfiguredyet": "Please configure the data table widget!"
    };
}
exports.widgets_en_us = widgets_en_us;
